import { Auftragsart, Auftragsposition } from "rage_api";

export const searchListe = (item, searchParams) => {
  const auftragsPosition = Auftragsposition.constructFromObject(item);
  const { search, art, items } = searchParams || {};
  const geschaeftsart = Auftragsart.constructFromObject(art);
  if (geschaeftsart && auftragsPosition.geschaeftsart !== geschaeftsart) return false;
  if (typeof search !== "string" || search.length < 3) return true;
  let regexBez = new RegExp(search.toLowerCase().trim(), "i");
  let regexKz = !isNaN(search) ? new RegExp("^" + Number(search)) : /^undefined/;
  let regexKonto = !isNaN(search) ? new RegExp(Number(search)) : /undefined/;
  let text = items ? items[auftragsPosition.kennziffer] : "";
  return !!(
    String(text).match(regexBez) ||
    String(auftragsPosition.text).toLowerCase().match(regexBez) ||
    String(auftragsPosition.kennziffer).match(regexKz) ||
    String(auftragsPosition.iban).substring(12).match(regexKonto)
  )
}
